import http from 'hub-http/clients/apiClient';
export const requestFetchPersonalizationVariants = ({
  id,
  contentPath
}) => http.get(`cospages/v2/${contentPath}/${id}/personalized-variants`);